import { Col, Row } from "react-bootstrap";
import {
  ISubmissionDetails,
  SubmissionOrObjection,
  SubmitterOrObjector,
  OralHearingValue,
} from "../../../api/ISubmission";
import EpaCard from "../../../leap-components/EpaCard";
import EpaField from "../../../leap-components/EpaField";

interface SubmissionDetailsProps {
  submissionDetails: ISubmissionDetails;
}

const SubmissionDetails = ({ submissionDetails }: SubmissionDetailsProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={`${SubmitterOrObjector(submissionDetails.type)} Type`}
            value={submissionDetails.objectortype}
          />
          <EpaField
            label={`${SubmitterOrObjector(submissionDetails.type)}`}
            value={submissionDetails.submitter}
          />
          <EpaField
            label="Oral Hearing Requested"
            value={`${OralHearingValue(
              submissionDetails.oralhearingrequested
            )}`}
          />
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField
            label="Received Date"
            value={submissionDetails.receiveddate}
          />
        </Col>
      </Row>
    </div>
  );

  return (
    <EpaCard
      title={`${SubmissionOrObjection(submissionDetails.type)} Details`}
      content={bodyElements}
    />
  );
};

export default SubmissionDetails;
